import React from 'react';
import ContentLoader, { Rect } from 'react-content-loader';

const Loader = props => (
  <div className="container-contentloader">
    <div>
      <ContentLoader height={65} speed={1} primaryColor={'#fff'} secondaryColor={'#e3e3e3'}>
        <Rect x={20} y={35} height={20} radius={4} width={180} />
      </ContentLoader>
    </div>

    <div>
      <ContentLoader height={65} speed={1} primaryColor={'#fff'} secondaryColor={'#e3e3e3'}>
        <Rect x={20} y={35} height={20} radius={4} width={150} />
      </ContentLoader>
    </div>

    <div>
      <ContentLoader height={65} speed={1} primaryColor={'#fff'} secondaryColor={'#e3e3e3'}>
        <Rect x={20} y={35} height={20} radius={4} width={200} />
      </ContentLoader>
    </div>
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/notices/Loader.js